// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yQ5E","option":"styles_option__13gtR","active":"styles_active__2rwEF"};